import { async } from '@angular/core/testing';
import { AgentService } from './../../../services/agent.service';
import { Utils } from './../../../utils';
import { ImageComponent } from './../../image/image.component';
import { AuthService } from './../../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from './../../../services/store.service';
import { CommandeService } from './../../../services/commande.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { DistriMagasinLivrer } from 'src/app/model/distri/DistriMagasinLivrer';
import { MessageService } from 'primeng-lts/api';
import { ConstService } from 'src/app/const.service';
import { BanqueService } from 'src/app/provider/admin/banque.service';
import { MagasinService } from 'src/app/provider/stock/magasin.service';

@Component({
  selector: 'app-newcommande',
  templateUrl: './newcommande.component.html',
  styleUrls: ['./newcommande.component.css']
})
export class NewcommandeComponent implements OnInit {
titre = 'Prise de commande Distri';
    msgs: Message[] = [];
    private msgTimeout: any;
    growlDefaultLife : number;
    droit : boolean = true;
    displaychargement : boolean;
    fr : any;
    itemId: any;
    
    displayCategorie: boolean;
    displayNafama: boolean;
    displayTelco: boolean;
    displayOmy: boolean;
    displaySim: boolean;
    displayTermineaux: boolean;
    displayCarte: boolean;

    selectedChoixMagasin:string;
    hasBoutique = false;
    listChoixMagasin: SelectItem[] = [];
    listMagasinAvecGerant: SelectItem[] = [];
    listDevise: SelectItem[] = [];
    listBanque: SelectItem[] = [];
    listModeReglement: SelectItem[] = [];
    listProduits: SelectItem[] = [];
    listNumeroPont: SelectItem[] = [];
    listZone: SelectItem[] = [];
    listTypeProduits: SelectItem[] = [];
    
    typeCommande: string;
    montant: number = 0;
    colorFieldset: string = 'primary';
    colorPanel: string = 'primary';
    itemBordereaux: CommandeBordereau[] = [];
    itemDetails: CommandeDetail[] = [];
    listReferences: SelectItem[] = [];
    allReferences: string = '';
    itemBordereau: CommandeBordereau;
    itemDetail: CommandeDetail;
    item: Commande;
    itemMagasinLivrer : DistriMagasinLivrer;
    totalMont: number=0;
    montantRestant: number=0;
    totalBorderaux: number=0;

    selectedTypeProduit: string='';
    selectedDevise: string='';
    selectedPdg: string;
    listLogin: SelectItem[] = [];

    displayTelcoProduit: boolean;
    displayTelcoDepot: boolean;

    today: any = new Date().toLocaleDateString();
    uploadedFiles: any[] = [];
    categoriePiece: string;
    piecesJointes: string;
    hasBanque = false;
    commentaire: string;
    libelleProduit: string;
    images = [];
    @ViewChild('inputimage',{static: false} ) inputimage;

    tauxEchange : number ;
    tauxEchangePue : number ;
    seuilArrondTollerance : number = 1 ;
    
    constructor(private messageService: MessageService,
                private constService: ConstService, 
                private confirmationService: ConfirmationService, 
                private router: Router, 
                private route: ActivatedRoute,
                private banqueService: BanqueService,
                private commandeService: CommandeService,
                public authService: AuthService, 
                private agentService: AgentService,
                private clientsService: ClientsService,
                private store: StoreService, 
                private magasinService: MagasinService,
            ) { 
    }

    //http://10.143.0.2:32004/kaabu-vente-service/magasins/search/all-magasins-avec-gerant

    async ngOnInit() {
        // // this.droit = this.constService.hasDroit("DS006");
        // if(!this.droit) {
        //   this.router.navigateByUrl('/distri/acceuil');
        // }
        this.fr = this.constService.custumDateFr;
        this.growlDefaultLife = this.constService.growlDefaultLife;
        this.listReferences.push({ label: 'Reference payement', value: '' });
        this.item = new Commande();
        this.selectedPdg = "";//this.authService.currentUser.nomPdg;
        this.loadSelectList();
        this.itemMagasinLivrer = new DistriMagasinLivrer();
        this.hasBoutique=true;
        this.selectedChoixMagasin="OUI";
        this.retour();
        this.piecesJointes = '';
        console.log("currentUser",this.authService.currentUser);
        console.log("this.constService.currentRoleDistri==="+this.constService.currentRoleDistri);
        const rawTaux = sessionStorage.getItem(this.constService.Dico.TAUX_ECHANGE);
        this.tauxEchange = rawTaux ? parseInt(rawTaux, 10) : 1;
        if (isNaN(this.tauxEchange) || this.tauxEchange <= 0) {
          this.tauxEchange = 1;
        }
        const rawPue = sessionStorage.getItem(this.constService.Dico.TAUX_ECHANGE_PUE);
        this.tauxEchangePue = rawPue ? +rawPue : 0.0095;
        if (isNaN(this.tauxEchangePue) || this.tauxEchangePue <= 0) {
          this.tauxEchangePue = 0.0095;
        }
        console.log("this.tauxEchange===="+this.tauxEchange);
        console.log("this.tauxEchangePue===="+this.tauxEchangePue);
        //this.images = this.printFileName(this.piecesJointes).split(';').filter(e => e.trim()).map(e => DistriUtils.newGalleryImage(e));
    }
    

    showMsg(severity: string, summary: string, detail: string) {
      this.msgs = [{severity: severity, summary: summary, detail: detail}];
      if (this.msgTimeout) { clearTimeout(this.msgTimeout); }
      this.msgTimeout = setTimeout(() => { this.msgs = []; }, 10000);
    }

    printFileName(names: string): string {
      if (names === null || names === undefined || names === "") {
          return "";
      }
      let images: string[] = names.split(";");
      if (images.length < 1) {
          return "";
      }
      let val = "";
      for (var i = 0; i < images.length; i++) {
          if (images[i] !== "") {
              val = val + images[i] + ".jpg;";
          }
      }
      return val;
    }
    printFileName2(names: string): string {
        const images = names.split(';').filter(e => e).map(a => a + '.jpg').join(';');
        console.log('images::', images);
        return images;
      }
    
      async saveCommande() {
        if (this.itemDetails === null || this.itemDetails === undefined) {
          this.showMsg('error', 'Erreur', 'la liste des produits est vide !');
          return;
        }
        if (this.itemDetails.length<=0) {
          this.showMsg('error', 'Erreur', 'la liste des produits est vide !');
          return;
        }
    
        if (this.itemBordereaux === null || this.itemBordereaux === undefined) {
          this.showMsg('error', 'Erreur', 'la liste des paiements est vide !');
          return;
        }
        if (this.itemBordereaux.length<=0) {
          this.showMsg('error', 'Erreur', 'la liste des paiements est vide !');
          return;
        }

        if (this.uploadedFiles == null || this.uploadedFiles === undefined) {
          this.showMsg('error', 'Erreur', 'Une pièce jointe est obligatoire !');
          return;
        }
        if (this.uploadedFiles.length <= 0) {
          this.showMsg('error', 'Erreur', 'Une pièce jointe est obligatoire !');
          return;
        }

        if (this.selectedPdg == null || this.selectedPdg === undefined || this.selectedPdg === '') {
          this.showMsg('error', 'Erreur', 'Le distributeur est obligatoire !');
          return;
        }

        if (this.selectedChoixMagasin == null || this.selectedChoixMagasin === undefined || this.selectedChoixMagasin === '') {
          this.showMsg('error', 'Erreur', 'Le choix du type Distributeur est obligatoire !');
          return;
        }

        let idMagasin = 0;
        if(this.selectedChoixMagasin === 'OUI') {
          if(!this.itemMagasinLivrer) {
            this.showMsg('error', 'Erreur', 'La boutique à livrer est obligatoire !');
            return;
          }
          if(!this.itemMagasinLivrer.idMagasin || this.itemMagasinLivrer.idMagasin <= 0) {
            this.showMsg('error', 'Erreur', 'La boutique à livrer est obligatoire !');
            return;
          }
          idMagasin = this.itemMagasinLivrer.idMagasin;
        }
        
        if (this.montant == null || this.montant === undefined || this.montant <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant global est incorrect !');
          return;
        }
        if (this.selectedDevise == null || this.selectedDevise === undefined || this.selectedDevise === '') {
          this.showMsg('error', 'Erreur', 'La devise est obligatoire !');
          return;
        }

        await this.calculerMontantAchat();

        if (this.totalBorderaux <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant bordereau est incorrect !');
          return;
        }
        if (this.montant != this.totalBorderaux) {
          this.showMsg('error', 'Erreur', 'Le montant global est incorrect !');
          return;
        }
        if (this.totalMont <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant achat est incorrect !');
          return;
        }
        if (this.montantRestant <  -1 ) {
          this.showMsg('error', 'Erreur', 'Le montant restant est incorrect !');
          return;
        }
        
        
        console.log("this.totalMont=====",this.totalMont);
        console.log("this.montantRestant=====",this.montantRestant);
        console.log("this.totalBorderaux=====",this.totalBorderaux);
    
        let workFlow;
        if (this.typeCommande === 'Airtime' || this.typeCommande === 'Telco') {
          workFlow = 3;
          for(let el of this.itemDetails){
            if(el.categorie==='PRODUIT') {
              workFlow = 1;
            }
          }
        } else if (this.typeCommande === 'Mobile Money') {
          workFlow = 2;
        } else {
          workFlow = 1;
        }
        console.log('currentAgent:', this.store.getValue('user'));
        const commandeToSent = {
          typeCommande: this.typeCommande,
          login: this.selectedPdg,
          //login: this.authService.currentUser.nomPdg,
          agent: this.store.getValue('user').id,
          devise: this.selectedDevise,
          tauxEchange: this.tauxEchange,
          dateCommande: new Date(),
          piecesJointes: '',
          montant: this.montant,
          etatAdv: true,
          statut: true,
          etat: 'ADV',
          listProduit: this.itemDetails,
          bordereaux: this.itemBordereaux,
          pieces: this.uploadedFiles,
          idWorkflow: workFlow,
          montantRestant: this.montantRestant,
          commentaire: this.commentaire,
          idMagasin: idMagasin
        };
        console.log('this.uploadedFiles: ', this.uploadedFiles);
        console.log('commandeToSent: ', commandeToSent);
    
        // await this.commandeService.save(commandeToSent).toPromise();
        // this.route.navigateByUrl('/root/list-commande');
        //const message = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure esse labore molestias, cum reprehenderit iusto illo eaque? Distinctio, cumque vel numquam enim, eos dolore molestias ipsum, tenetur ipsam fugiat ad.';
        let message = 'Voulez vous valider la commande ?';
        if(this.montantRestant > 0) {
          message = 'Attention, le montant restant est '+this.montantRestant+' !! Voulez vous valider la commande ?';
        }
        this.saveCommandeWithConfirmation(commandeToSent, message);

      }
    //9852 

      async saveBordereau() {
        if (this.itemBordereau === null || this.itemBordereau === undefined) {
          this.showMsg('error', 'Erreur', 'Paiement est vide !');
          return;
        }
        if (this.itemBordereau.montant === null || this.itemBordereau.montant === undefined || this.itemBordereau.montant <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant est incorrect !');
          return;
        }
        if (this.itemBordereau.reference === null || this.itemBordereau.reference === undefined || this.itemBordereau.reference === '') {
          this.showMsg('error', 'Erreur', 'La reference est obligatoire !');
          return;
        }
        if ((this.itemBordereau.banque === null || this.itemBordereau.banque === undefined || this.itemBordereau.banque === '')
          && this.hasBanque) {
          this.showMsg('error', 'Erreur', 'La banque est obligatoire !');
          return;
        }
        if (this.itemBordereau.modePayement === null || this.itemBordereau.modePayement === undefined
          || this.itemBordereau.modePayement === '') {
          this.showMsg('error', 'Erreur', 'Le mode de payement est obligatoire !');
          return;
        }
        
        if (this.itemBordereau.montant === null || this.itemBordereau.montant === undefined || this.itemBordereau.montant <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant est incorrect !');
          return;
        }
        
        const foundReference = this.listReferences.find(e => e.value === this.itemBordereau.reference);
        if (foundReference) {
          this.showMsg('error', 'Erreur', 'La reference est incorrecte !');
          return;
        }
        
        /*
        const foundBordereau = this.itemBordereaux.find(e => e.modePayement === this.itemBordereau.modePayement);
        if (foundBordereau) {
          this.messageService.clear(); this.messageService.add({life: 15000, severity: 'error', summary: 'Erreur', detail: 'Un seul bordereau est autorisé !' });
          return;
        }
        */
        
        if (this.itemBordereau.montant === null || this.itemBordereau.montant === undefined || this.itemBordereau.montant <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant est incorrect !');
          return;
        }
        
        let montant = 0;
        this.itemBordereaux.forEach(e => {
          montant = montant + e.montant;
        });
        
        if (montant + this.itemBordereau.montant > this.montant) {
          this.showMsg('error', 'Erreur', 'La somme des montants est superieure au montant global !');
          return;
        }
        
        try {
          console.log("============debut chechBorderauMode======");
          let data  = await this.commandeService.chechBorderauRef(this.itemBordereau.reference).toPromise() as any;
          console.log("============chechBorderauMode======",data);
          if(data && data.message !== 'OK'){
            this.showMsg('error', 'Erreur', data.message);
            return;
          }
        } catch (error) {
          console.log("error======",error);
          this.showMsg('error', 'Erreur', 'Une erreur c\'est produite lors de la validation de la reference');
          return;
        }
        
        this.listReferences.push({ label: this.itemBordereau.reference, value: this.itemBordereau.reference });
        this.itemBordereaux.push(this.cloneObject(this.itemBordereau, new CommandeBordereau()));
        this.showMsg('info', 'Confirmation', 'Paiement ajouté avec succès');
        this.itemBordereau = new CommandeBordereau();
        this.calculerMontantAchat();
      }
    
      saveDetailsProduit() {
        if (this.itemDetail === null || this.itemDetail === undefined) {
          this.showMsg('error', 'Erreur', 'Paiement est vide !');
          return;
        }
        if (this.itemDetail.montant === null || this.itemDetail.montant === undefined || this.itemDetail.montant < 0) {
          this.showMsg('error', 'Erreur', 'Le montant est incorrect !');
          return;
        }

        let refPaie = '';
        for(let e of this.itemBordereaux){
          refPaie = refPaie + e.reference + ";";
        }
        this.itemDetail.referencePayement = refPaie;
        if (this.itemDetail.referencePayement === null || this.itemDetail.referencePayement === undefined || this.itemDetail.referencePayement === '') {
          this.showMsg('error', 'Erreur', 'La reference de payement est obligatoire !');
          return;
        }
        
        if(this.itemDetail.quantite === null || this.itemDetail.quantite === undefined || this.itemDetail.quantite <= 0) {
          this.showMsg('error', 'Erreur', 'La quantite est incorrect !');
          return;
        }
        if (this.selectedDevise == null || this.selectedDevise === undefined || this.selectedDevise === '') {
          this.showMsg('error', 'Erreur', 'La devise est obligatoire !');
          return;
        }
        
        // const montant = this.itemDetails.length === 0 ? 0 : this.itemDetails.map(e => e.montant).reduce((t, e) => t + e);
        const bordereauSelected = this.itemBordereaux.find(e => e.reference === this.itemDetail.referencePayement);
        const itemsBrothers = this.itemDetails.filter(e => e.referencePayement === this.itemDetail.referencePayement);
        const montantItemsBrothers = itemsBrothers.length === 0 ? 0 : itemsBrothers.map(e => (e.montant || 0) * (e.quantite || 0) ).reduce((t, e) => t + e, 0);
        const montantItems = this.itemDetails.length === 0 ? 0 : this.itemDetails.map(e => (e.montant || 0) * (e.quantite || 0) ).reduce((t, e) => t + e, 0);
        let newMontant = (this.itemDetail.montant || 0) * (this.itemDetail.quantite || 0) ;
        console.log('newMontant ', newMontant);

        if ( (montantItems + newMontant) > (this.montant + (+this.seuilArrondTollerance)) ) {
          this.showMsg('error', 'Erreur', 'La somme des montants ajoutés est superieure au montant global de la commande !');
          return;
        }
        this.itemDetail.categorie="PRODUIT";
        this.itemDetail.tauxEchange = (this.selectedDevise === 'USD') ? 1 : (this.tauxEchange || 1);
        this.itemDetails.push(Object.assign({}, this.itemDetail));
        this.showMsg('info', 'Confirmation', 'Produit ajouté avec succès');
        console.log('itemDetails: ' + this.itemDetails);
        this.itemDetail = new CommandeDetail();
        this.calculerMontantAchat();
      }

      saveDetailsDepot() {
        if (this.itemDetail === null || this.itemDetail === undefined) {
          this.showMsg('error', 'Erreur', 'Paiement est vide !');
          return;
        }
        if (this.itemDetail.montant === null || this.itemDetail.montant === undefined || this.itemDetail.montant <= 0) {
          this.showMsg('error', 'Erreur', 'Le montant est incorrect !');
          return;
        }
      
        let refPaie = '';
        for(let e of this.itemBordereaux){
          refPaie = refPaie + e.reference + ";";
        }
        this.itemDetail.referencePayement = refPaie;
        if (this.itemDetail.referencePayement === null || this.itemDetail.referencePayement === undefined || this.itemDetail.referencePayement === '') {
          this.showMsg('error', 'Erreur', 'La reference de payement est obligatoire !');
          return;
        }
    
        if(this.itemDetail.msisdn === null || this.itemDetail.msisdn === undefined || this.itemDetail.msisdn === '') {
          this.showMsg('error', 'Erreur', 'Le Numéro est obligatoire !');
          return;
        }
        if (this.selectedDevise == null || this.selectedDevise === undefined || this.selectedDevise === '') {
          this.showMsg('error', 'Erreur', 'La devise est obligatoire !');
          return;
        }

        
        this.itemDetail.quantite=1;
        if(this.selectedDevise === 'USD'){
          this.itemDetail.tauxEchange = 1;
        } else {
          this.itemDetail.tauxEchange = this.tauxEchange || 1;
        }
        if(this.typeCommande==='Mobile Money'){
          this.itemDetail.pue=1;
          this.itemDetail.montantDepot=this.itemDetail.montant;
        } else {
          this.itemDetail.pue = this.tauxEchangePue || 0.0095;
          const taux = this.itemDetail.tauxEchange || 1;
          const pue = this.itemDetail.pue || 0.0095;
          this.itemDetail.montantDepot = Math.ceil(this.itemDetail.montant / taux / pue);
        }
        /*
        console.log("this.tauxEchange===="+this.tauxEchange);
        console.log("this.itemDetail.pue===="+this.itemDetail.pue);
        console.log("this.itemDetail.montant===="+this.itemDetail.montant);
        console.log("this.itemDetail.montant DEP===="+(this.itemDetail.montant/this.itemDetail.pue));
        console.log("this.itemDetail.montantDepot===="+this.itemDetail.montantDepot);
        //*/

        // const montant = this.itemDetails.length === 0 ? 0 : this.itemDetails.map(e => e.montant).reduce((t, e) => t + e);
        const bordereauSelected = this.itemBordereaux.find(e => e.reference === this.itemDetail.referencePayement);
        const itemsBrothers = this.itemDetails.filter(e => e.referencePayement === this.itemDetail.referencePayement);
        const montantItemsBrothers = itemsBrothers.length === 0 ? 0 : itemsBrothers.map(e => (e.montant || 0) * (e.quantite || 0) ).reduce((t, e) => t + e, 0);
        const montantItems = this.itemDetails.length === 0 ? 0 : this.itemDetails.map(e => (e.montant || 0) * (e.quantite || 0) ).reduce((t, e) => t + e, 0);
        let newMontant = (this.itemDetail.montant || 0) * (this.itemDetail.quantite || 0) ;
        console.log('newMontant ', newMontant);

        if (montantItems + newMontant > this.montant) {
          this.showMsg('error', 'Erreur', 'La somme des montants ajoutés est superieure au montant global de la commande !');
          return;
        }
        if(this.typeCommande==='Mobile Money'){
          this.itemDetail.categorie="Mobile Money";
          if(!this.itemDetail.libelle) {
            this.itemDetail.libelle = "Mobile Money";
          }
        } else {
          this.itemDetail.categorie="Airtime";
          if(!this.itemDetail.libelle) {
            this.itemDetail.libelle = "Airtime";
          }
        }
        this.itemDetails.push(Object.assign({}, this.itemDetail));
        this.showMsg('info', 'Confirmation', 'Produit ajouté avec succès');
        console.log('itemDetails: ' + this.itemDetails);
        this.itemDetail = new CommandeDetail();
        this.calculerMontantAchat();
      }

      async calculerMontantAchat(){
        this.totalMont = this.itemDetails.length === 0 ? 0 : this.itemDetails.map(e => (e.montant || 0) * (e.quantite || 0) ).reduce((t, e) => t + e, 0);
        this.montantRestant = this.montant - this.totalMont;
        this.totalBorderaux = this.itemBordereaux.length === 0 ? 0 : this.itemBordereaux.map(e => e.montant).reduce((t, e) => t + e);
      }
    
      onDeleteDetails(el) {
        console.log('el: ', el);
        console.log('ref:', this.findItemDetailsIndex(el.reference));
        console.log('itemDetails:', this.itemDetails);
        this.itemDetails.splice(this.itemDetails.indexOf(el), 1);
        this.showMsg('info', 'Confirmation', 'Produit supprimé avec succès');
        this.calculerMontantAchat();
      }
      onDeleteBordereau(el) {
        console.log(el.reference + '===========' + this.findItemBordereauxIndex(el.reference));
        this.itemBordereaux.splice(this.findItemBordereauxIndex(el), 1);
        this.showMsg('info', 'Confirmation', 'Paiement supprimé avec succès');
        console.log('this.listReferences.findIndex(el.reference)', this.listReferences.indexOf(el.reference));
        this.listReferences.splice(this.listReferences.indexOf(el), 1);
        this.calculerMontantAchat();
      }
    
      async newCommandeTelco() {
        this.displayCategorie = false;
        this.displayNafama = false;
        this.displayTelco = true;
        this.displayOmy = false;
        this.displaySim = false;
        this.displayTermineaux = false;
        this.displayCarte = false;
        this.typeCommande = 'Telco';
        this.colorFieldset = 'myfield6';
        this.colorPanel = 'primary';
        this.itemBordereau = new CommandeBordereau();
        this.itemDetail = new CommandeDetail();
        this.item = new Commande();

        this.itemMagasinLivrer = new DistriMagasinLivrer();
        this.hasBoutique=true;
        this.selectedChoixMagasin="OUI";

        this.itemBordereaux = [];
        this.itemDetails = [];
        this.listReferences = [{ label: 'Reference payement', value: '' }];
        this.getListMsisdn('', 'TELCO');
        this.listProduits = [];
        await this.getProduits();
      }
      newCommandeNafama() {
        this.displayCategorie = false;
        this.displayNafama = true;
        this.displayTelco = false;
        this.displayOmy = false;
        this.displaySim = false;
        this.displayTermineaux = false;
        this.displayCarte = false;
        this.typeCommande = 'Airtime';
        this.colorFieldset = 'myfield6';
        this.colorPanel = 'primary';
        this.itemBordereau = new CommandeBordereau();
        this.itemDetail = new CommandeDetail();
        this.item = new Commande();
        this.itemBordereaux = [];
        this.itemDetails = [];
        this.listReferences = [{ label: 'Reference payement', value: '' }];
        this.getListMsisdn('', 'TELCO');
      }
      async newCommandeOmy() {
        this.displayCategorie = false;
        this.displayNafama = false;
        this.displayTelco = false;
        this.displayOmy = true;
        this.displaySim = false;
        this.displayTermineaux = false;
        this.displayCarte = false;
        this.typeCommande = 'Mobile Money';
        this.colorFieldset = 'myfield2';
        this.colorPanel = 'info';
        this.itemBordereau = new CommandeBordereau();
        this.itemDetail = new CommandeDetail();
        this.item = new Commande();

        this.itemMagasinLivrer = new DistriMagasinLivrer();
        this.hasBoutique=false;
        this.selectedChoixMagasin="NON";

        this.listNumeroPont = [];
        this.listReferences = [{ label: 'Reference payement', value: '' }];
        await this.getListMsisdn('', 'OMY');
      }
      
      async newCommandeProduit() {
        this.displayCategorie = false;
        this.displayNafama = false;
        this.displayTelco = false;
        this.displayOmy = false;
        this.displaySim = false;
        this.displayTermineaux = true;
        this.displayCarte = false;
        this.typeCommande = 'Produits';
        this.colorFieldset = 'myfield1';
        this.colorPanel = 'success';
        this.itemBordereau = new CommandeBordereau();
        this.itemDetail = new CommandeDetail();
        this.item = new Commande();
        this.listProduits = [];
        await this.getProduits();
      }
    
      retour() {
        this.displayCategorie = true;
        this.displayNafama = false;
        this.displayTelco = false;
        this.displayOmy = false;
        this.displaySim = false;
        this.displayTermineaux = false;
        this.displayCarte = false;
        this.itemBordereau = null;
        this.itemDetail = null;
      }
    
      async loadSelectList() {

        this.listDevise = [];
        this.listDevise.push({ label: 'Devise...', value: '' });
        this.listDevise.push({ label: 'CDF', value: 'CDF' });
        this.listDevise.push({ label: 'USD', value: 'USD' });

        this.listTypeProduits = [];
        this.listTypeProduits.push({ label: 'PRODUIT', value: 'PRODUIT' });
        this.listTypeProduits.push({ label: 'DEPOT AIRTIME', value: 'DEPOT' });
        this.selectedTypeProduit='PRODUIT';
        this.displayTelcoProduit=true;
        this.displayTelcoDepot=false;

        if(this.store.isUserPartenaire) {
          this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
          this.selectedPdg = this.store.currentNomPDG;
          this.onChangePDG(this.store.currentNomPDG);
        } else {
          this.selectedPdg = "";
          this.listLogin.push({ label: 'Selectionner...', value: null });
          try {
            console.log("==========dataRetourPdg==========");
            let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
            console.log("==========dataRetourPdg=========="+JSON.stringify(dataRetourPdg));
            for (let el of dataRetourPdg) {
              this.listLogin.push({ label: el.login + " - " + el.msisdn, value: el.login });
            }
          } catch (error) { }
        }
    
        this.listBanque = [];
        this.listBanque.push({label:'Banque...', value:null});
        console.log("before call");
        await this.banqueService.getList().then( (data: any) =>  {
          for(let d of data) {
              this.listBanque.push({label:d.libelle, value:d.libelle});
          }
        });

        this.listMagasinAvecGerant = [];
        try {
          this.listMagasinAvecGerant.push({label:'Boutiques...', value:null});
          this.magasinService.findMagasinsGerant().then( (data: any) =>  {
            for(let d of data) {
                this.listMagasinAvecGerant.push({label:d.nomMagasin, value:d});
            }
          });
          
        } catch (error) {
          console.log(error);
          
        }

        
        this.listChoixMagasin = [];
        this.listChoixMagasin.push({ label: 'selectionner...', value: null });
        this.listChoixMagasin.push({ label: 'OUI', value: 'OUI' });
        this.listChoixMagasin.push({ label: 'NON', value: 'NON' });
        
        this.listModeReglement = [];
        this.listModeReglement.push({ label: 'Mode reglement...', value: null });
        this.listModeReglement.push({ label: 'BORDEREAU', value: 'BORDEREAU' });
        this.listModeReglement.push({ label: 'AVIS DE DEBIT', value: 'AVIS DE DEBIT' });
        this.listModeReglement.push({ label: 'CHEQUE CERTIFIE', value: 'CHEQUE CERTIFIE' });
        this.listModeReglement.push({ label: 'FACTURE AVOIR', value: 'FACTURE AVOIR' });
        this.listModeReglement.push({ label: 'MARGE ARRIERE', value: 'MARGE ARRIERE' });
        this.listModeReglement.push({ label: 'CREDIT REVOLVING', value: 'CREDIT REVOLVING' });
        this.listModeReglement.push({ label: 'REMBORSEMENT UV', value: 'REMBORSEMENT UV' });
        this.listModeReglement.push({ label: 'AVANCE SUR FACTURE', value: 'AVANCE SUR FACTURE' });
    
      }
    
    
      async getListMsisdn(login: any, type: any) {
        this.listNumeroPont=[];
        if(!this.store.isUserPartenaire&&(login === null || login === undefined || login === '')) {
          console.log('listMsisdn: ', this.listNumeroPont);
          //this.messageService.clear(); this.messageService.add({life: 15000, severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un login PDG ' });
          return;
        }
        console.log('listMsisdn: ', this.listNumeroPont);
        this.listNumeroPont = [
          { label: 'MSISDN...', value: null },
          ...(await this.agentService.findMsisdnByType(this.store.isUserPartenaire ? this.store.currentNomPDG : login,type).toPromise() as any).map(element => {
            return {
              label: element.msisdn, value: element.msisdn
            };
          })];
        console.log('listMsisdn: ', this.listNumeroPont);
      }
    
      async onChangePDG(val) {
        console.log("onChangePDG======"+val);
        if(this.typeCommande === 'Mobile Money') {
          this.getListMsisdn(val, 'OMY');
        } else {
          this.getListMsisdn(val, 'TELCO');
        }
      }
    
    
    
      findItemBordereauxIndex(id): number {
        this.itemId = id;
        return this.itemBordereaux.findIndex(this.testItemIdReference, this);
      }
      findItemDetailsIndex(id): number {
        this.itemId = id;
        return this.itemDetails.findIndex(this.testItemIdReference, this);
      }
      testItemIdReference(value, index, array): boolean {
        return value.reference === this.itemId;
      }
      public cloneObject(source, clone) {
        for (let prop in source) {
          clone[prop] = source[prop];
        }
        return clone;
      }
      public isObjectsEquals(a, b) {
        var isOK = true;
        for (var prop in a) {
          if (a[prop] !== b[prop]) {
            isOK = false;
            break;
          }
        }
        return isOK;
      }
    
      /*
      deleteFiles() {
        this.piecesJointes = '';
        this.uploadedFiles = [];
        this.images = [];
        this.showMsg('info', 'Confirmation', 'Images suprimées');
      }
      */

      deleteFiles() {
        this.confirmationService.confirm({
            message: 'Voulez-vous supprimer toutes les pièces ?',
            accept: () => {
                this.piecesJointes = '';
                this.uploadedFiles = [];
                this.inputimage.clearFileNames();
                this.showMsg('info', 'Confirmation', 'Pièces supprimées avec succès !');
            }
        });
      }
    
      async detectFiles0(event) {
        console.log('files: ', event.target.files);
        const files = [];
        for (let i = 0; i < event.target.files.length; i++) {
          files.push(event.target.files[i]);
        }
        await Promise.all(files.map(async file => {
          try {
            const filesNames = (await this.commandeService.sendToOpenStack(file, files.indexOf(file)).toPromise() as any);
            console.log('filesNames: ', filesNames);
            filesNames.forEach(async (element: any) => {
              this.uploadedFiles.push({
                nom: element,
                categorie: this.categoriePiece,
                agent: this.authService.currentUser.login,
                profil: this.constService.currentRoleDistri
              });
            });
          } catch (error) {
          }
        }));
        console.log('uploadedFiles: ', this.uploadedFiles);
        this.piecesJointes = '';
        this.uploadedFiles.forEach(e => {
          this.piecesJointes = this.piecesJointes + e.nom + ';';
        });
        console.log('piecesJointes: ', this.piecesJointes);
        //this.images = this.printFileName(this.piecesJointes).split(';').filter(e => e.trim()).map(e => DistriUtils.newGalleryImage(e));
        //console.log('images: ', this.images);
        console.log('this.printFileName(this.piecesJointes): ', this.printFileName(this.piecesJointes));

        this.inputimage.clearFileNames();
        //this.inputimage.addFileNames(this.images);
        this.inputimage.addFileNames(this.printFileName(this.piecesJointes));
      }
    
      async getProduits() {
        this.listProduits = [
          { label: 'Produit...', value: null },
          ...(await this.commandeService.getProduit().toPromise() as any).content.map(element => {
            return {
              label: element.libelle, value: element
            };
          })];
        // console.log('listProduits: ', this.listProduits);
      }

      onChangeTypeProduit(data) {
        console.log('event :' + data);
        this.displayTelcoProduit=false;
        this.displayTelcoDepot=false;
        if(data === 'DEPOT') {
          this.displayTelcoDepot=true;
        } else {
          this.displayTelcoProduit=true;
        }
      }

      onChangeDevise(data) {
        console.log('event :' + data);
        if (this.selectedDevise == null || this.selectedDevise === undefined || this.selectedDevise === '') {
          this.showMsg('error', 'Erreur', 'La devise est obligatoire !');
          return;
        }
        if(this.itemDetail !== null && this.itemDetail !== undefined 
          && this.itemDetail.libelle !== null && this.itemDetail.libelle !== undefined 
          && this.itemDetail.libelle !== '' && this.typeCommande === 'Produits' && this.displayTermineaux) {
            this.onChangeProduit(this.libelleProduit);
        }
      }
    
      onChangeProduit(data) {
        //const data = event.value;
        console.log('event :', data);
        const found = this.listProduits.find(e => e.value === data);
        console.log('produit: ', found);
        console.log('found.value.libelle.libelle: ', found.value.libelle);
        if (this.selectedDevise == null || this.selectedDevise === undefined || this.selectedDevise === '') {
          this.showMsg('error', 'Erreur', 'La devise est obligatoire !');
          return;
        }
        if (found) {
          const unitPrice = found.value.unitPrice || found.value.prix || 0;
          if(this.selectedDevise === 'CDF') {
            this.itemDetail.montant = unitPrice * (this.tauxEchange || 1);
          } else {
            this.itemDetail.montant = unitPrice;
          }
          
          this.itemDetail.libelle = (found.value.referenceOracle || '') + '-' + (found.value.libelle || '');
          this.itemDetail.codeOracle = found.value.referenceOracle;
          this.itemDetail.idProduit = found.value.id;
        }
      }
    
    
      onChangeModePaiement(event) {
        const data = event.value;
        console.log('event :' + data);
        this.hasBanque = data === 'BORDEREAU' ? true : false;
      }
      onChangeChoixBoutique(event) {
        const data = event.value;
        console.log('event :' + data);
        this.hasBoutique = data === 'OUI' ? true : false;
        this.itemMagasinLivrer = new DistriMagasinLivrer();
      }
    
      async saveCommandeWithConfirmation(commandeToSent: any, message: any) {
        this.confirmationService.confirm({
          message: message,
          accept: async () => {
            this.displaychargement = true;
            try {
              await this.commandeService.save(commandeToSent).toPromise();
              this.displaychargement = false;
              this.showMsg('info', 'Confirmation', 'Commande ajouté avec succès');
              setTimeout(()=>{
                console.log('waiting');
                this.ngOnInit();
                // this.router.navigateByUrl('/distri/acceuil');
              }, 100);
            } catch (error) {
              console.log("catch error===="+error);
              this.displaychargement = false;
              this.showMsg('error', 'Erreur', error);
            } finally {
              this.displaychargement = false;
            }
          }
        });
      }
    
    }
    